module.exports = __webpack_public_path__ + "static/media/Verona.0e8b9342.png";